import {
    SET_SCROLL,
    LOCK_SCROLL,
} from 'vue/vuex/mutation-types';

export function setScroll({ commit }, { position, progress, scrollbarWidth }) {
    commit(SET_SCROLL, { position, progress, scrollbarWidth });
}

export function lockScroll({ commit }, { isLocked }) {
    commit(LOCK_SCROLL, { isLocked });
}



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/modules/scroll/actions.js